import { handleActions } from 'redux-actions';
import { Actions } from '../constants';

const initialState = [];

export default handleActions(
  {
    [Actions.UPDATE_SEARCH_PARAMS]: (_, { payload: { suitableFor = [] } }) =>
      Array.isArray(suitableFor) ? suitableFor : [suitableFor],
  },
  initialState,
);

export const getSuitableForFilter = state => state;
